import { Button, Modal } from 'shared/components/ui';
import React from 'react';

import './DocumentViewer.css';

const DocumentViewer = ({ show, onHide, url, title = 'Documento' }) => {
  if (!url) return null;

  const fileExtension = url.split('.').pop().toLowerCase();
  const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(fileExtension);
  const isPdf = fileExtension === 'pdf';
  
  // Agregar timestamp para evitar caché
  const urlWithTimestamp = url + (url.includes('?') ? '&' : '?') + 't=' + Date.now();

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      size="xl" 
      centered
      className="document-viewer-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="document-viewer-body">
        {isImage ? (
          <img src={url} alt={title} className="document-viewer-image" />
        ) : isPdf ? (
          <iframe 
            src={urlWithTimestamp} 
            title={title}
            className="document-viewer-iframe"
          />
        ) : (
          <div className="document-viewer-unsupported">
            <p>Vista previa no disponible para este tipo de archivo.</p>
            <Button
              variant="primary" 
              href={url} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Descargar archivo
            </Button>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary" 
          href={url} 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Abrir en nueva pestaña
        </Button>
        <Button variant="primary" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DocumentViewer;
